import React from 'react';
import {
  FiAlertTriangle,
  FiInfo,
  FiAlertCircle,
  FiZap,
  FiXCircle,
} from 'react-icons/fi';
import { APP_HEX } from '@/constant/theme/colors.constant';

export enum AlertLevel {
  WARNING = 'WARNING',
  MINOR = 'MINOR',
  MAJOR = 'MAJOR',
  CRITICAL = 'CRITICAL',
  FATAL = 'FATAL',
}

export const LEVEL_COLOR: Record<string, string> = {
  WARNING: APP_HEX.warning,
  MINOR: APP_HEX.blue,
  MAJOR: APP_HEX.orange,
  CRITICAL: APP_HEX.danger,
  FATAL: APP_HEX.fatal,
};

export const AlertLevelIcon: React.FC<{
  level?: string | number | null;
  className?: string;
}> = ({ level, className = 'w-4 h-4' }) => {
  const lvl = (
    typeof level === 'string' ? level : String(level ?? '')
  ).toUpperCase();
  const color = LEVEL_COLOR[lvl] ?? APP_HEX.muted;
  const props = { className, style: { color } };
  switch (lvl) {
    case AlertLevel.WARNING:
      return <FiAlertTriangle {...props} />;
    case AlertLevel.MINOR:
      return <FiInfo {...props} />;
    case AlertLevel.MAJOR:
      return <FiAlertCircle {...props} />;
    case AlertLevel.CRITICAL:
      return <FiZap {...props} />;
    case AlertLevel.FATAL:
      return <FiXCircle {...props} />;
    default:
      return null;
  }
};

export const renderLevelIcon = (level?: string | number | null) => (
  <AlertLevelIcon level={level} />
);

export default renderLevelIcon;
